module.exports = __webpack_public_path__ + "static/media/indylogo.2ef0adfc.png";